/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateRestowFromRemainOnBoardCommand } from '../model';
// @ts-ignore
import type { RemainOnBoardUnitUpsertedDto } from '../model';
// @ts-ignore
import type { RestowResponseDto } from '../model';
// @ts-ignore
import type { UpsertRestowListCommand } from '../model';
/**
 * RemainOnBoardUnitsApi - axios parameter creator
 */
export const RemainOnBoardUnitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateRestowFromRemainOnBoardCommand} [createRestowFromRemainOnBoardCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRestowFromRemainOnBoard: async (createRestowFromRemainOnBoardCommand?: CreateRestowFromRemainOnBoardCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/RemainOnBoardUnits/CreateRestowFromRemainOnBoard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRestowFromRemainOnBoardCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [vesselVisitId] 
         * @param {string} [containerNumber] 
         * @param {boolean} [isNotOnTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (vesselVisitId?: number, containerNumber?: string, isNotOnTerminal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/RemainOnBoardUnits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (vesselVisitId !== undefined) {
                localVarQueryParameter['VesselVisitId'] = vesselVisitId;
            }

            if (containerNumber !== undefined) {
                localVarQueryParameter['ContainerNumber'] = containerNumber;
            }

            if (isNotOnTerminal !== undefined) {
                localVarQueryParameter['IsNotOnTerminal'] = isNotOnTerminal;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vesselVisitId 
         * @param {string} containerNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRemainOnBoardByVisitAndContainer: async (vesselVisitId: number, containerNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselVisitId' is not null or undefined
            assertParamExists('getRemainOnBoardByVisitAndContainer', 'vesselVisitId', vesselVisitId)
            // verify required parameter 'containerNumber' is not null or undefined
            assertParamExists('getRemainOnBoardByVisitAndContainer', 'containerNumber', containerNumber)
            const localVarPath = `/planning/api/RemainOnBoardUnits/GetRemainOnBoardByVisitAndContainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (vesselVisitId !== undefined) {
                localVarQueryParameter['VesselVisitId'] = vesselVisitId;
            }

            if (containerNumber !== undefined) {
                localVarQueryParameter['ContainerNumber'] = containerNumber;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vesselVisitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRestowsByVesselVisit: async (vesselVisitId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselVisitId' is not null or undefined
            assertParamExists('getRestowsByVesselVisit', 'vesselVisitId', vesselVisitId)
            const localVarPath = `/planning/api/RemainOnBoardUnits/GetRestowsByVesselVisit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (vesselVisitId !== undefined) {
                localVarQueryParameter['VesselVisitId'] = vesselVisitId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRestow: async (ids: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('removeRestow', 'ids', ids)
            const localVarPath = `/planning/api/RemainOnBoardUnits/RemoveRestow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (ids) {
                localVarQueryParameter['Ids'] = ids;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRestowJourney: async (ids: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('removeRestowJourney', 'ids', ids)
            const localVarPath = `/planning/api/RemainOnBoardUnits/RemoveRestowJourney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (ids) {
                localVarQueryParameter['Ids'] = ids;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertRestowListCommand} [upsertRestowListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restows: async (upsertRestowListCommand?: UpsertRestowListCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/RemainOnBoardUnits/Restows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertRestowListCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RemainOnBoardUnitsApi - functional programming interface
 */
export const RemainOnBoardUnitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RemainOnBoardUnitsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateRestowFromRemainOnBoardCommand} [createRestowFromRemainOnBoardCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRestowFromRemainOnBoard(createRestowFromRemainOnBoardCommand?: CreateRestowFromRemainOnBoardCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRestowFromRemainOnBoard(createRestowFromRemainOnBoardCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RemainOnBoardUnitsApi.createRestowFromRemainOnBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [vesselVisitId] 
         * @param {string} [containerNumber] 
         * @param {boolean} [isNotOnTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(vesselVisitId?: number, containerNumber?: string, isNotOnTerminal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RemainOnBoardUnitUpsertedDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(vesselVisitId, containerNumber, isNotOnTerminal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RemainOnBoardUnitsApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} vesselVisitId 
         * @param {string} containerNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRemainOnBoardByVisitAndContainer(vesselVisitId: number, containerNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemainOnBoardUnitUpsertedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRemainOnBoardByVisitAndContainer(vesselVisitId, containerNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RemainOnBoardUnitsApi.getRemainOnBoardByVisitAndContainer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} vesselVisitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRestowsByVesselVisit(vesselVisitId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RestowResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRestowsByVesselVisit(vesselVisitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RemainOnBoardUnitsApi.getRestowsByVesselVisit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeRestow(ids: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeRestow(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RemainOnBoardUnitsApi.removeRestow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeRestowJourney(ids: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeRestowJourney(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RemainOnBoardUnitsApi.removeRestowJourney']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertRestowListCommand} [upsertRestowListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restows(upsertRestowListCommand?: UpsertRestowListCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restows(upsertRestowListCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RemainOnBoardUnitsApi.restows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RemainOnBoardUnitsApi - factory interface
 */
export const RemainOnBoardUnitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RemainOnBoardUnitsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateRestowFromRemainOnBoardCommand} [createRestowFromRemainOnBoardCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRestowFromRemainOnBoard(createRestowFromRemainOnBoardCommand?: CreateRestowFromRemainOnBoardCommand, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.createRestowFromRemainOnBoard(createRestowFromRemainOnBoardCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [vesselVisitId] 
         * @param {string} [containerNumber] 
         * @param {boolean} [isNotOnTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(vesselVisitId?: number, containerNumber?: string, isNotOnTerminal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<RemainOnBoardUnitUpsertedDto>> {
            return localVarFp.get(vesselVisitId, containerNumber, isNotOnTerminal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vesselVisitId 
         * @param {string} containerNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRemainOnBoardByVisitAndContainer(vesselVisitId: number, containerNumber: string, options?: RawAxiosRequestConfig): AxiosPromise<RemainOnBoardUnitUpsertedDto> {
            return localVarFp.getRemainOnBoardByVisitAndContainer(vesselVisitId, containerNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vesselVisitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRestowsByVesselVisit(vesselVisitId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RestowResponseDto>> {
            return localVarFp.getRestowsByVesselVisit(vesselVisitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRestow(ids: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeRestow(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRestowJourney(ids: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeRestowJourney(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertRestowListCommand} [upsertRestowListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restows(upsertRestowListCommand?: UpsertRestowListCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.restows(upsertRestowListCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RemainOnBoardUnitsApi - object-oriented interface
 */
export class RemainOnBoardUnitsApi extends BaseAPI {
    /**
     * 
     * @param {CreateRestowFromRemainOnBoardCommand} [createRestowFromRemainOnBoardCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createRestowFromRemainOnBoard(createRestowFromRemainOnBoardCommand?: CreateRestowFromRemainOnBoardCommand, options?: RawAxiosRequestConfig) {
        return RemainOnBoardUnitsApiFp(this.configuration).createRestowFromRemainOnBoard(createRestowFromRemainOnBoardCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [vesselVisitId] 
     * @param {string} [containerNumber] 
     * @param {boolean} [isNotOnTerminal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public get(vesselVisitId?: number, containerNumber?: string, isNotOnTerminal?: boolean, options?: RawAxiosRequestConfig) {
        return RemainOnBoardUnitsApiFp(this.configuration).get(vesselVisitId, containerNumber, isNotOnTerminal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vesselVisitId 
     * @param {string} containerNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRemainOnBoardByVisitAndContainer(vesselVisitId: number, containerNumber: string, options?: RawAxiosRequestConfig) {
        return RemainOnBoardUnitsApiFp(this.configuration).getRemainOnBoardByVisitAndContainer(vesselVisitId, containerNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vesselVisitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRestowsByVesselVisit(vesselVisitId: number, options?: RawAxiosRequestConfig) {
        return RemainOnBoardUnitsApiFp(this.configuration).getRestowsByVesselVisit(vesselVisitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeRestow(ids: Array<number>, options?: RawAxiosRequestConfig) {
        return RemainOnBoardUnitsApiFp(this.configuration).removeRestow(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeRestowJourney(ids: Array<number>, options?: RawAxiosRequestConfig) {
        return RemainOnBoardUnitsApiFp(this.configuration).removeRestowJourney(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertRestowListCommand} [upsertRestowListCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public restows(upsertRestowListCommand?: UpsertRestowListCommand, options?: RawAxiosRequestConfig) {
        return RemainOnBoardUnitsApiFp(this.configuration).restows(upsertRestowListCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

